<template>
  <div class="about">
    <div class="row">
      <div class="left">
        <h2>About me</h2>
        <div class="profileImage">
        <img src="/Benjamin1.jpg">
        </div>
      </div>
      <div class="right">
        <h1>Benjamin Mättö - Programmer</h1>
        <p>
          I am interested in programming and technology in all shapes and sizes. Right now I work on games, mostly in C++. Recently I've been working on
          networking and engine programming, but I am open to any and all new experiences, as all parts of the IT world make me excited.
        </p>
        <h3>Contact info</h3>
        <li>
          Phone: +46724481532
        </li>
        <li>
          Email: <a href="mailto:benjaminmatto00@gmail.com">benjaminmatto00@gmail.com</a>
        </li>
        <li>
          <a href="/Resume-2021-04.pdf">Resume</a>
        </li>
        <p>
          This website was made using Vue.js.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
h3{
  margin-left: 10%;
  font-size: 40px;
  margin-bottom: 1%;
}
  p{
    margin-left: 10%;
  }
  li{
    margin-left: 10%;
  }
  img{
    max-width: 100%;
    height: auto;
  }
  .profileImage{
    width: 100%;
    height: 100%;
  }
  .row{
    display: flex;
  }
  .left{
    flex: 66%;
  }
  .right{
    flex: 33%;
  }
  h2{
    position: relative;
    top: 30px;
    padding: 0 0;
    margin: 0 0;
    text-align: left;
    font-size: 72px;
    z-index: 1;
  }
</style>